import { useState } from "react";


export const useDeleteUser = () => {
    const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);
    const [modalTitle, setModalTitle] = useState<string>("");
    
    const onSubmit = () => {
        console.log("onSubmit");
    }
    
    return {
        openModalDelete,
        setOpenModalDelete,
        modalTitle,
        setModalTitle,
        onSubmit,
        
    }
}
